import React from "react"

import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import { Editor } from '@tinymce/tinymce-react'
import { I18n } from 'react-redux-i18n'

import { setDescription } from '../../../actions/updateAppointmentActions'

const styles = theme => ({
  container: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  input:{
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 'calc(100% - ' + theme.spacing.unit*2 + 'px)',
  },
  descriptionLabel:{
    color: 'rgba(0, 0, 0, 0.54)',
    padding: '0',
    fontSize: '0.75rem',
    lineHeight: '1',
    marginLeft: '8px',
  },
  errorLabelContainer:{
    margin: theme.spacing.unit,
  },
  errorLabel:{
    color: theme.palette.error.main,
  }
});

class Description extends React.Component {
  render() {
    const { classes } = this.props

    let error = false
    let errorMessage = ''

    if(this.props.updateAppointment.error != null ){
      if(this.props.updateAppointment.error.errors.description != null){
        error = true
        errorMessage = this.props.updateAppointment.error.errors.description[0]
      }
    }

    return (
      <Grid container className={classes.container}>
        <Grid item xs={12}>
          <span className={classes.descriptionLabel}>{I18n.t('editAppointment.description')}</span>
        </Grid>
        <Grid item xs={12} className={classes.errorLabelContainer}>
          <label className={classes.errorLabel}>
            {error ?
              (
                errorMessage
              ) : (
                null
              )

            }
          </label>
        </Grid>
        <Grid item xs={12}>
          <Editor
            id="editDescription"
            initialValue=""
            value={this.props.updateAppointment.description}
            init={{
              theme: 'modern',
              branding: false,
              menubar: false,
              toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code',
              language: this.props.locale,
              setup: function(editor) {
                  editor.on('undo', function(e) {
                      this.props.dispatch(setDescription(window.tinyMCE.activeEditor.getContent()))
                  }.bind(this))

                  editor.on('redo', function(e) {
                      this.props.dispatch(setDescription(window.tinyMCE.activeEditor.getContent()))
                  }.bind(this))
              }.bind(this)
            }}
            onChange={this.props.handleEditorChange}/>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(Description)



// WEBPACK FOOTER //
// ./src/js/components/pages/updateAppointment/Description.js